import { CheckIcon } from 'lucide-react';

import { TocCardState } from './toc-card';

type TocIndicatorProps = {
  readonly state: TocCardState;
};

const TocIndicator = ({ state }: TocIndicatorProps) => {
  if (state === 'to-do') {
    return (
      <div className="flex w-[16px] h-[16px] rounded-full border-2 border-neutral-400 mx-0.5 bg-neutral-0 z-[11]"></div>
    );
  }
  return (
    <div className="flex w-[20px] h-[20px] rounded-full bg-green-400 items-center justify-center z-[11]">
      <CheckIcon className="text-neutral-0" size={12} />
    </div>
  );
};

export { TocIndicator };
